import { Color } from '../../../../../../../../styles/commonStyles'
import { intl } from '../../../../../../../../i18n'
import { WbsItemRow } from '../../../../../../../../lib/functions/wbsItem'
import SmokeIcon from '../../../../../../../components/icons/SmokeIcon'
import { WbsItemStatus } from '.'
import WbsItemRowApi from '../../../../lib/wbsItem/index'
import FireIcon from '@mui/icons-material/LocalFireDepartmentRounded'
import Tooltip from '../../../../../../../components/tooltips/Tooltip'

export const DelayIcon = (props: {
  wbsItem: Partial<WbsItemRow>
  fontSize?: number
}) => {
  const { wbsItem, fontSize } = props
  if (!wbsItem || !wbsItem.status) return <></>
  const todo = wbsItem.status === WbsItemStatus.TODO
  const completed = [WbsItemStatus.DONE, WbsItemStatus.DISCARD].includes(
    wbsItem.status
  )
  if (WbsItemRowApi.isEndDelayed(wbsItem)) {
    return (
      <Tooltip message={intl.formatMessage({ id: 'wbs.end.delayed' })}>
        <FireIcon
          style={{
            color: completed ? Color.DISABLED : Color.ALERT,
            fontSize: fontSize || 16,
          }}
        />
      </Tooltip>
    )
  } else if (WbsItemRowApi.isStartDelayed(wbsItem)) {
    return (
      <Tooltip message={intl.formatMessage({ id: 'wbs.start.delayed' })}>
        <SmokeIcon
          style={{
            color: todo ? Color.ALERT : Color.DISABLED,
            fontSize: fontSize || 16,
          }}
        />
      </Tooltip>
    )
  }
  return <></>
}
